import { createIconComponent } from '../../factory/create-icon-component';
export const CircleDollarIcon = createIconComponent(
  'CircleDollarIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 2.83209C14.7751 2.2969 13.4222 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.74835 21.2558 7.67051 20 5.99902M8.99988 14C8.99988 15.1046 9.89531 16 10.9999 16H13.2565C14.2193 16 14.9999 15.2194 14.9999 14.2566C14.9999 13.5062 14.5197 12.8399 13.8078 12.6026L10.192 11.3974C9.48007 11.1601 8.99988 10.4938 8.99988 9.74342C8.99988 8.78055 9.78043 8 10.7433 8H12.9999C14.1044 8 14.9999 8.89543 14.9999 10M11.9999 6.5V17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
